import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import easing from 'ui/styles/easing'

const Wrapper = styled.div`
  width: 50px;
  height: 50px;
  background: ${props => props.theme.colors.pacific.base};
  position: absolute;
  bottom: 100%;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transform: ${props => props.active ? 'rotate(-45deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ${easing.easeOutCubic};
  }
`

export default class Plus extends Component {
  static propTypes = {
    active: PropTypes.bool.isRequired
  }

  render() {
    return(
      <Wrapper active={this.props.active}>
        <svg
          width="19"
          height="19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 9.5h17M9.5 1v17"
            stroke="#FFF"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Employees/Plus.js